(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumMessageDialogController', RptCompendiumMessageDialogController);

    RptCompendiumMessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RptCompendiumMessage', 'RptLanguage', 'Compendium', 'Clinic'];

    function RptCompendiumMessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RptCompendiumMessage, RptLanguage, Compendium, Clinic) {
        var vm = this;

        vm.rptCompendiumMessage = entity;
        vm.clear = clear;
        vm.save = save;
        vm.rptLanguages = RptLanguage.query();
        vm.compendiums = Compendium.query();
        vm.clinics = Clinic.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptCompendiumMessage.id !== null) {
                RptCompendiumMessage.update(vm.rptCompendiumMessage, onSaveSuccess, onSaveError);
            } else {
                RptCompendiumMessage.save(vm.rptCompendiumMessage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptCompendiumMessageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
